import { langKey } from "@/i18n";
import http_lan_map from "@/constants/http.lan.config";
import { normalizeLang } from "@/i18n/lang.utils";
import { getSearchParam } from "@/utils";
import { isTrTabLanguageHost, resolveTrTabLanguageCode } from "@/utils/trTabLanguageResolver";

export const getLangMap = (): string => {
  const { lan, curLan } = useLanguage("");
  const { subdomain, domain } = useSubdomain();
  const { hostName } = useHostName();
  const lanParam = getSearchParam("lan");
  const conParam = getSearchParam("con");
  const channelParam = getSearchParam("channel");
  const normalizedLangCode = normalizeLang(lan);

  if (isTrTabLanguageHost({ hostName, domain, subdomain, channel: channelParam })) {
    return resolveTrTabLanguageCode({
      lan: lanParam,
      con: conParam,
    });
  }

  // 合法语言直接返回
  if (normalizedLangCode && langKey.includes(normalizedLangCode)) {
    return curLan;
  }

  // 微信域名强制俄语
  if (hostName === "wx.mobi321.com" || domain === "wx.mobi321.com") {
    return "ru-ru";
  }

  // 域名匹配
  const hostLanguage = http_lan_map[hostName];
  if (hostLanguage) return hostLanguage;

  // 子域名匹配
  if (subdomain && !["test", "www"].includes(subdomain)) {
    const subDomainKey = `${subdomain}.comfortweather.com`;
    const subLanguage = http_lan_map[subDomainKey];
    if (subLanguage) return subLanguage;
  }

  return "en";
};
